<script lang="ts">
    import type { Activity } from "../global";
    import type Checkpoint from "../Model/Checkpoint";
    import ActivityBtn from './ActivityBtn.svelte';

    export let checkpoint: Checkpoint;

    let activities: Activity[] = [];

    $: getActivities(checkpoint);

    async function getActivities(checkpoint: Checkpoint) {
        activities = await checkpoint.getActivities();
    }

</script>

<style lang="scss">

    .checkpoint-activites {
        margin-top: 1rem;
        display: flex;
        justify-content: center;
    }

</style>

<div class="checkpoint-activites">
    {#each activities as activity}
        <ActivityBtn {checkpoint} {activity} />
    {/each}
</div>
